import gql from "graphql-tag";

import {FetchPolicy} from "@khanacademy/wonder-blocks-data";
import {useQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    getFavoritedTeacherTools_aiGuideFavoritedTeacherTools as AiGuideFavoritedTeacherTools,
    getFavoritedTeacherTools,
    getFavoritedTeacherToolsVariables,
} from "./__graphql-types__/getFavoritedTeacherTools.ts";

export const GET_FAVORITED_TEACHER_TOOLS: GqlOperation<
    getFavoritedTeacherTools,
    getFavoritedTeacherToolsVariables
> = gqlOp(gql`
    query getFavoritedTeacherTools {
        aiGuideFavoritedTeacherTools {
            id
            configName
        }
    }
`);

export const useGetFavoritedTeacherTools = (): {
    favoritedTeacherTools: Array<AiGuideFavoritedTeacherTools>;
    status: string;
} => {
    const [results] = useQuery(GET_FAVORITED_TEACHER_TOOLS, {
        variables: {},
        fetchPolicy: FetchPolicy.NetworkOnly,
    });

    if (results.status !== "success") {
        return {
            favoritedTeacherTools: [],
            status: results.status,
        };
    }

    const tools = results.data?.aiGuideFavoritedTeacherTools ?? [];

    return {
        favoritedTeacherTools: tools.filter(
            Boolean,
        ) as AiGuideFavoritedTeacherTools[],
        status: results.status,
    };
};
